import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { NoRecords } from '../../Components/Shimmer';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { currentDateAndTime, decodeUrl } from '../../Constants/constants';
import { useRowSelect } from 'react-table';
import { decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';

const PayrollOtherHeadInput = () => {
const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
    const decodedDataId = decodeUrl(encodedData);
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [rows, setRows] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [rowColumns, setRowColumns] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    // const []
    const [filter, setFilter] = useState({
        keyword: null,
        month: null,
        location: null,
        department: null,
    });
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });
    const limitOptions = [10, 25, 50, 100, 200, 500];


    const getList = () => {
        const headers = apiHeaderJSON;
        console.log("filter?.month", filter?.month);
        axios
            .get(`${apiURL}Payrolls/GetPayrollOtherHeadInputScreenTemplate`, {
                params: {
                    limit: pagination?.limit || 10,
                    page: pagination?.page || 1,
                    keyword: filter?.keyword,
                    month: filter?.month,
                    location_id: filter?.location,
                    department_id: filter?.department,
                },
                headers,
            })
            .then((response) => {
                var data = response.data;
                if (data?.success === true) {
                    // console.log(data);
                    setPagination({
                        next: data?.response?.next,
                        prev: data?.response?.prev,
                        page: data?.response?.page,
                        total_records: data?.response?.total_records,
                        total_pages: data?.response?.total_pages,
                        loadingList: false,
                    })
                    setRows(data?.response?.data);
                    setHeaders(data?.PayrollOtherHeadsTemplateArray);
                    setRowColumns(data?.columnToMap);

                } else {
                    setPagination({ ...pagination, loadingList: false });
                }
            });
    };

    // useEffect(() => {
    //     if(filter?.keyword){
    //         getList();
    //     }
    // }, [filter?.keyword]);

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterData)
                    setFilter({
                        ...filter,
                        month: data?.filterData[0]?.value || null
                    });
                } else {

                }
            });
    };
    const getDepartmentFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetDepartments`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getDepartmentFilterList", data);
                if (data?.success === true) {
                    let row = data?.departments?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    // row?.splice(0, 0, { value: "All", label: "All" });
                    // let allDepartmentRow = data?.departments?.map((val) => {
                    //     return val?.department_id
                    // });
                    // allDepartmentRow = allDepartmentRow?.join(",");
                    setDepartment(row)


                } else {

                }
            });
    };
    const getLocationFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetLocations`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getLocationFilterList", data);
                if (data?.success === true) {
                    let row = data?.locations?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    setLocation(row);


                } else {

                }
            });
    };
    useEffect(() => {
        getMonthFilterList();
        getList();
        getDepartmentFilterList();
        getLocationFilterList();
    }, []);

    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
        console.log("ids", ids);
        // if (!ids || ids?.length === 0) {
        //     setIsChanged(true);
        // }
    };

    const handleSlabChange = (index, fieldName, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [fieldName]: value,
        };
        setRows(updatedRows);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map(row => row.employee_id));
        } else {
            setSelectedRows([]);
        }
    };
    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
        if (!e.target.value) {
            setIsChanged(true);
        }
    };
    const handleCheckboxChange = (employeeId) => {
        if (selectedRows.includes(employeeId)) {
            setSelectedRows(selectedRows.filter(id => id !== employeeId));
        } else {
            setSelectedRows([...selectedRows, employeeId]);
        }
    };

    const handleSelectAllDropdown = (action) => {
        if (action === 'select-all') {
            setSelectedRows(rows.map(row => row.employee_id));
        } else if (action === 'deselect-all') {
            setSelectedRows([]);
        }
    };

    const handleInputSearch = (e) => {
        getList();
    }

    const handleClearAll = () => {
        setFilter({
            keyword: null,
            month: monthOptions[0]?.value,
            location: null,
            department: null,
        });
        setIsChanged(true);
    }

    useEffect(() => {
        if (isChanged) {
            getList();
            setIsChanged(false);
        }

    }, [isChanged])

    const handlePrev = (ev) => {

        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                prev: pagination?.prev - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                next: pagination?.next + 1
            });
            setIsChanged(true);
        }
    }
    const handleChange = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged(true);
    };

    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Payroll Other Head Input`} primary={`Home`} />

                    <div className="card">

                        <div className="card-body">
                            <div className="row mb-3">
                                {/* <div className='col-md-2'>
                                    <label> Select Month </label>
                                    <Select
                                        options={monthOptions}
                                        value={
                                            filter?.month
                                                ? monthOptions.find(option => option.value === filter?.month)
                                                : null
                                        }
                                        onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                        placeholder={`Select Month`} />
                                </div> */}
                                <div className='col-md-3'>
                                    <label htmlFor="keyword">Search By Name</label>
                                    <div className="input-group">
                                        <input type="search" className="form-control" onChange={handleInputChange} name="keyword" value={filter?.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Enter Name" />
                                        <button className="btn btn-success" onClick={handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative'>
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Select Month </label>
                                        <Select
                                            options={monthOptions}
                                            value={
                                                filter?.month
                                                    ? monthOptions.find(option => option.value === filter?.month)
                                                    : null
                                            }
                                            onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                            placeholder={`Select Month`} />
                                    </div>
                                </div>
                                <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label>Department</label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={department}
                                            // isDisabled={!filter?.month}
                                            value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Location </label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={location}
                                            // isDisabled={!filter?.month}
                                            value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "10%" }} className='col-md-2'>
                                    <div>
                                        <label>Apply Filter</label>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => { getList() }}
                                        disabled={loadingFilter}
                                        className={`${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''}  btn btn-info btn-label waves-effect waves-light noWrap`}>
                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                        {!loadingFilter ? "Filter" : "Loading..."}
                                    </button>
                                </div>
                                <div style={{ width: "10%" }} className='col-md-2'>
                                    <div> <label>Clear Filter</label> </div>
                                    <button type="button"
                                        // disabled={loading}
                                        className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''}`}
                                        onClick={handleClearAll}
                                    >
                                        <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                </div>

                            </div>
                            <div className="row">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                    <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed table-hover" style={{ width: '100%' }} aria-describedby="example_info">
                                        <thead className="table-light sticky-top z-1">
                                            <tr>
                                                {/* {rows?.length > 0 ?
                                                    <th>
                                                        <div className="btn-group" style={{ background: "rgb(221 224 227)" }}>
                                                            <button type="button" className="btn">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={selectedRows.length === rows.length}
                                                                    onChange={handleSelectAll}
                                                                />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn dropdown-toggle dropdown-toggle-split"
                                                                id="dropdownMenuReference"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                data-bs-reference="parent"
                                                                style={{ background: "#c7c7c7" }}
                                                            >
                                                                <span className="visually-hidden">Toggle Dropdown</span>
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuReference">
                                                                <li>
                                                                    <button className="dropdown-item" onClick={() => handleSelectAllDropdown('select-all')}>
                                                                        Select All
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="dropdown-item" onClick={() => handleSelectAllDropdown('deselect-all')}>
                                                                        Deselect All
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </th> : null
                                                } */}

                                                {headers?.map((val) => {
                                                    return <th>{val}</th>
                                                })}
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tbody> :
                                            <tbody>
                                                {rows?.map((row, idx) => (
                                                    <tr key={row.employee_id}>
                                                        {/* <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={selectedRows.includes(row.employee_id)}
                                                                    onChange={() => handleCheckboxChange(row.employee_id)}
                                                                />
                                                            </div>
                                                        </td> */}
                                                        <td>{row.Employee_code}</td>
                                                        <td>{row.Employee_name}</td>
                                                        {rowColumns?.map((col, index) => {
                                                            return (<td>
                                                                {/* <div>
                                                                <input
                                                                    type="number"
                                                                    id="Arrear_days"
                                                                    name="Arrear_days"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row?.Arrear_days}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Arrear_days",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div> */}
                                                                {row[col]}
                                                            </td>)
                                                        })

                                                        }
                                                        {/* <td>{row.Arrear_salary_month_year}</td> */}
                                                        {/* <td>
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    id="Arrear_ot_hours"
                                                                    name="Arrear_ot_hours"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row.Arrear_ot_hours}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Arrear_ot_hours",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div>
                                                            {row.Arrear_ot_hours}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    id="Reimbursement"
                                                                    name="Reimbursement"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row.Reimbursement}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Reimbursement",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div>
                                                            {row.Reimbursement}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    id="Incentive"
                                                                    name="Incentive"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row.Incentive}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Incentive",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div>
                                                            {row.Incentive}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    id="Earned_Other_Earning"
                                                                    name="Earned_Other_Earning"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row.Earned_Other_Earning}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Earned_Other_Earning",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div>
                                                            {row.Earned_Other_Earning}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    id="Income_Tax"
                                                                    name="Income_Tax"
                                                                    placeholder="Enter"
                                                                    // ref={headAgeNumberRef}
                                                                    value={row.Income_Tax}
                                                                    onChange={(e) =>
                                                                        handleSlabChange(
                                                                            idx,
                                                                            "Income_Tax",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100`}
                                                                />
                                                            </div>
                                                            {row.Income_Tax}
                                                        </td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        }

                                    </table>

                                </div>
                                <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={pagination?.prev === false && pagination?.loadingList === false ? true : false} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChange(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={pagination?.next === false && pagination?.loadingList === false ? true : false} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollOtherHeadInput;
